/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".center-text[_ngcontent-%COMP%] {\n  text-align: center;\n}\n.changelog-table[_ngcontent-%COMP%] {\n  width: calc(100% - 50px);\n  margin: 25px;\n}\n.width-10[_ngcontent-%COMP%] {\n  width: 10%;\n}\n.width-15[_ngcontent-%COMP%] {\n  width: 15%;\n}\n.width-20[_ngcontent-%COMP%] {\n  width: 20%;\n}\n.width-50[_ngcontent-%COMP%] {\n  width: 50%;\n}\ntd[_ngcontent-%COMP%]   a[_ngcontent-%COMP%] {\n  color: #FFF;\n}\ntd[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover {\n  color: #0074D9;\n}"];
export { styles as styles };
